import { useQuery } from '@tanstack/react-query';
import { adsService } from '../services/ads.service';

export function useShopSubscribersCount() {
  return useQuery({
    queryKey: ['ads', 'audience', 'subscribers'],
    queryFn: () => adsService.getShopSubscribersCount(),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}

export function useProductLikersCount() {
  return useQuery({
    queryKey: ['ads', 'audience', 'product-likers'],
    queryFn: () => adsService.getProductLikersCount(),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
